import type { ResponseReadAll } from "epsm-api-types";
import type { Company } from "epsm-api-types/models";
import type { IReadAllParams } from "@/services/RequestParams";
import { useGetData } from "../../../../hooks/useGetData";
import type { IpoInfo } from "../interfaces/IpoInfo";
import { CompanyService } from "./CompanyService";
import { IpoService } from "./IpoService";

export interface Options {
	params: IReadAllParams;
}

export interface IpoOptions {
	ticker: string;
}

export class UseData {
	private constructor(
		private ipoService: IpoService,
		private companyService: CompanyService,
	) {}

	private static instance: UseData;

	static create() {
		if (!UseData.instance) {
			UseData.instance = new UseData(
				IpoService.create(),
				CompanyService.create(),
			);
		}
		return UseData.instance;
	}

	getIposData = async ({ ticker }: IpoOptions): Promise<IpoInfo | null> => {
		return await this.ipoService.getData(ticker);
	};

	getCompanyData = async ({
		params,
	}: Readonly<Options>): Promise<ResponseReadAll<Company>> => {
		return await this.companyService.getData(params);
	};

	useGetIposData = () =>
		useGetData<IpoInfo | null, IpoOptions>(this.getIposData);

	useGetCompanyData = () =>
		useGetData<ResponseReadAll<Company>, Readonly<Options>>(
			this.getCompanyData,
		);
}
